import _ from 'lodash';

const methods = {
  lower(val) {
    return (val || '').toLowerCase();
  },
  capitalize(val) {
    return _.capitalize(val);
  }
};

export default methods;
